<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='120px' :model='queryInfo'>
        <div class='searchBox'>
          <div class='content'>
            <el-row>
              <el-col :span='5'>
                <el-form-item label='问题标题：'>
                  <el-input
                    clearable
                    v-model.trim='
                                                queryInfo.problemTitle
                                            '
                    style='width: 100%'
                    placeholder='请输入标题'
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class='btn'>
            <el-button type='primary' @click='querySearch' class='searchBtns'
            >查询
            </el-button
            >
          </div>
        </div>
      </el-form>
    </global-tag>
    <div class='table_title'>
      <div class='btn_group'>
        <el-button
          type='success'
          class='button openBtns'
          @click="handleTableForm('新增', 'add')"
        >新增
        </el-button
        >
        <el-button
          type='primary'
          class='button downOutBtns'
          @click='createExcel'
        >导出数据
        </el-button
        >
        <div style='display: none'>
          <input @change='fileChange' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>导入数据</span>
        </label>
        <!-- <el-button-group>
            <el-button
                type="success"
                icon="iconfont icon-xinzeng"
                @click="handleTableForm('新增', 'add')"
                >新增</el-button
            >
        </el-button-group> -->
      </div>
    </div>
    <!-- tableb表格 -->
    <div class='table_container'>
      <el-table
        :data='tableData'
        tooltip-effect='dark'
        style='width: 100%'
        height='550px'
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column
          type='index'
          width='70'
          label='序号'
          align='center'
          v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label='问题标题'
          align='center'
          prop='problemTitle'
          v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '问题标题'
                        ) != -1
                    "
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label='问题'
          align='center'
          prop='problem'
          v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '问题'
                        ) != -1
                    "
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label='答案'
          align='center'
          prop='solution'
          v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '答案'
                        ) != -1
                    "
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          label='操作'
          align='center'
          width='200px'
          fixed='right'
          v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
        >
          <template slot-scope='scope'>
                        <span
                          @click="handleTableForm('详情', scope.row)"
                          style='margin-right: 12px; cursor: pointer'
                        >查看</span
                        >
            <span
              @click="handleTableForm('编辑', scope.row)"
              style='margin-right: 12px; cursor: pointer'
            >编辑</span
            >
            <span
              @click='deleteItem(scope.row)'
              style='margin-right: 12px; cursor: pointer'
            >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container'>
      <el-pagination
        :page-size='pageOne.pageSize'
        :current-page.sync='pageOne.pageNo'
        layout='total, sizes, prev, pager, next, jumper'
        :total='pageOne.total'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination>
    </div>
    <add-info
      v-if='addressSate'
      :openData='addressInfo'
      @cancleAddress='cancleAddress'
    ></add-info>
  </div>
</template>
<script>
import addInfo from './components/addInfo.vue'

export default {
  inject: ['reload'], //注入
  components: { addInfo },
  data() {
    return {
      addressSate: false,
      addressInfo: {},
      queryInfo: { problemTitle: '' },
      showAddStatus: false,
      personIdCard: '',
      isSearchContent: false,
      pageOne: { pageSize: 10, pageNo: 1, total: 0 },
      tableData: [],
      dialogVisible: false, //人员编辑
      dialogInfo: {},
      personState: false, //新增人员
      personInfo: {},
      radioId: '',
      tempTableChekbox: ['序号', '问题标题', '问题', '答案', '操作'],
      tableChekbox: ['序号', '问题标题', '问题', '答案', '操作']
    }
  },
  created() {
    this.getList()
  },
  methods: {
    cancleAddress(data) {
      this.addressSate = false
      if (data == true) {
        this.getList()
      }
    },
    // 搜索
    querySearch() {
      this.getList()
    },
    // 关闭人员信息弹窗
    cancleOpen() {
      this.dialogInfo = {}
      this.dialogVisible = false
      // this.tableData = [];
      this.getList()
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id
      }
      this.$confirm('确认永久删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .request({
            url: '/ypt/admin/problemBase/info/deleteById',
            method: 'POST',
            data: params
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              // this.tableData = [];
              this.getList()
            }
          })
      })
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //重置
    clearData() {
      this.reload()
    },
    //导出excel
    async createExcel() {
      const res = await this.request2({
        url: '/ypt/admin/problemBase/info/downloadExcel',
        method: 'POST',
        data: this.queryInfo,
        responseType: 'blob'
      })
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const fileName = '问题库.xls'
      const linkNode = document.createElement('a')

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = 'none'
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    // 导入
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = '1'
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let formData = new FormData()
      formData.append('personType', personType)
      console.log(formData)
      formData.append('file', file)
      let result = await this.$http.post(
        '/ypt/admin/problemBase/info/excel',
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById('speechUpload')
      fileEle.value = ''
      if (result.code == 200) {
        this.$message.success(result.message)
        this.getList()
      } else {
        this.$message.warning(result.message)
      }
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        problemTitle: this.queryInfo.problemTitle
      }
      this.$http
        .request({
          url: '/ypt/admin/problemBase/info/findList',
          method: 'POST',
          data: params
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    // 操作方法
    handleTableForm(title, row) {
      this.addressInfo = {
        title: title,
        id: title == '新增' ? '' : row.id,
        state: true
      }
      this.addressSate = true
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .table_title {
  margin-top: 20px !important;
}

.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
